<template>
  <div>
    <ul class="bushel-documents-list mt-2">
      <li
        v-for="listItem in listItems"
        :key="listItem.key"
        class="float-left mb-2"
      >
        <div v-if="listItem.appDocuType == 'document'">
          <a
            v-if="isDownloadable"
            :id="'bushel_download_icon_' + listItem.uuid"
            :href="downloadLink(listItem)"
            :download="listItem.name"
            class="clickable"
            target="_blank"
          >
            <i
              class="bushel-icon bushel-2x"
              :class="documentIcon(listItem)"
            />
            <BTooltip
              :target="'bushel_download_icon_' + listItem.uuid"
              placement="top"
              triggers="hover"
            >
              Download {{ certificationType ? certificationType : listItem.label }} Download
            </BTooltip>
          </a>
          <span v-if="!isDownloadable">
            <i
              :id="'bushel_download_icon_' + listItem.uuid"
              class="bushel-icon bushel-2x"
              :class="documentIcon(listItem)"
            />
            <BTooltip
              :target="'bushel_download_icon_' + listItem.uuid"
              placement="top"
              triggers="hover"
            >
              {{ certificationType ? certificationType : listItem.label }} Document
            </BTooltip>
          </span>
        </div>
        <div
          v-if="listItem.appDocuType == 'lab-result'"
          class="bg-light p-1 rounded ml-1"
        >
          <img
            :id="'lab_result_icon_' + listItem.key"
            src="/img/vendor-logos/metrc-verified.svg"
            alt="metrc verified"
            class="img-fluid"
            style="max-width: 60px; width: 100%; margin: 0 0 0 0; cursor: default; cursor: help"
          >
          <BTooltip
            v-if="!useLabPopOver"
            :target="'lab_result_icon_' + listItem.key"
            triggers="hover focus click"
          >
            <ul
              class="list-group list-group-flush rounded"
              style="background: transparent"
            >
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Type
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestTypeName }}
                </span>
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Passed
                <span
                  class="badge badge-pill ml-4"
                  :class="listItem.OverallPassed ? 'text-danger' : 'text-success'"
                >
                  {{ listItem.OverallPassed ? "Yes" : "No" }}
                </span>
              </li>
              <li
                v-if="listItem.TestResultLevel"
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Level
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestResultLevel }}
                </span>
              </li>
              <li
                v-if="listItem.TestPerformedDate"
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Test Date
                <span class="badge badge-pill ml-4">
                  {{ dateShortLocalized(listItem.TestPerformedDate) }}
                </span>
              </li>
              <li
                v-if="listItem.LabFacilityName"
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Lab
                <span class="badge badge-pill ml-4">
                  {{ listItem.LabFacilityName }}
                </span>
              </li>
              <li
                v-if="listItem.TestComment"
                class="list-group-item d-flex justify-content-between align-items-center"
                style="background: transparent"
              >
                Comments
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestComment }}
                </span>
              </li>
            </ul>
          </BTooltip>
          <b-popover
            v-if="useLabPopOver"
            :target="'lab_result_icon_' + listItem.key"
            :delay="popoverDelay"
            triggers="hover focus"
            placement="bottom"
          >
            <template #title>
              <img
                src="/img/vendor-logos/metrc-verified.svg"
                alt="metrc verified"
                class="img-fluid"
                style="max-width: 60px; width: 100%; margin: 0 10px 0 0"
              >
              Lab Tested Results
            </template>
            <ul class="list-group list-group-flush rounded">
              <li class="list-group-item d-flex justify-content-between align-items-center">
                Type
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestTypeName }}
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center">
                Passed
                <span
                  class="badge badge-pill ml-4"
                  :class="listItem.OverallPassed ? 'text-danger' : 'text-success'"
                >
                  {{ listItem.OverallPassed ? "Yes" : "No" }}
                </span>
              </li>
              <li
                v-if="listItem.TestResultLevel"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                Level
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestResultLevel }}
                </span>
              </li>
              <li
                v-if="listItem.TestPerformedDate"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                Test Date
                <span class="badge badge-pill ml-4">
                  {{ dateShortLocalized(listItem.TestPerformedDate) }}
                </span>
              </li>
              <li
                v-if="listItem.LabFacilityName"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                Lab
                <span class="badge badge-pill ml-4">
                  {{ listItem.LabFacilityName }}
                </span>
              </li>
              <li
                v-if="listItem.TestComment"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                Comments
                <span class="badge badge-pill ml-4">
                  {{ listItem.TestComment }}
                </span>
              </li>
            </ul>
          </b-popover>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { dateShortLocalized } from "@/services/filters";

export default {
  name: "ProductDisplayDocumentsList",
  props: {
    documents: { type: Array, required: true },
    labResults: {
      type: Array,
      default() {
        return [];
      },
    },
    isDownloadable: { type: Boolean, default: false },
    certificationType: { type: String, default: null },
    popoverDelay: {
      type: Object,
      default() {
        return { show: 100, hide: 0 };
      },
    },
    useLabPopOver: { type: Boolean, default: true },
  },
  computed: {
    listItems() {
      const listItems = [];
      if (this.documents && this.documents.length > 0) {
        this.documents.forEach((doc, docIndex) => {
          const listItem = doc;
          listItem.appDocuType = "document";
          listItem.key = `document_${doc.id}`;
          listItems.push(listItem);
        });
      }
      if (this.labResults && this.labResults.length > 0) {
        this.labResults.forEach((labResult, labResultIndex) => {
          const listItem = labResult;
          listItem.appDocuType = "lab-result";
          if (listItem.show_on_storefront) {
            listItems.push(listItem);
          }
        });
      }
      return listItems;
    },
  },
  methods: {
    dateShortLocalized,
    documentIcon(doc) {
      let typeCheck = doc.label;
      if (this.certificationType) {
        typeCheck = this.certificationType;
      }
      if (typeCheck == "Potency") {
        return "bushel-potency";
      }
      if (typeCheck == "Heavy Metal") {
        return "bushel-heavy-metal";
      }
      if (typeCheck == "Pesticides") {
        return "bushel-pesticides";
      }
      if (typeCheck == "Full Panel") {
        return "bushel-full-panel";
      }
      if (typeCheck == "Moisture Content") {
        return "bushel-moisture";
      }
      if (typeCheck == "Microbials") {
        return "bushel-microbials";
      }
      if (typeCheck == "Field Test") {
        return "bushel-field-test";
      }
      if (typeCheck == "Terpenes") {
        return "bushel-terpenes";
      }
      if (typeCheck == "Misc") {
        return "bushel-misc";
      }
      if (typeCheck == "Certification") {
        return "bushel-checked";
      }
      if (typeCheck == "Certicate of Analysis") {
        return "bushel-checked";
      }
      if (typeCheck == "GMP Certification") {
        // return 'bushel-misc';
        return "bushel-ops-gmp fa-rotate-270 rounded";
      }
      if (typeCheck == "Operation License") {
        return "bushel-checked";
      }
      if (
        typeCheck == "USDA" ||
        typeCheck == "Organic Land Certification" ||
        typeCheck == "USDA Organic & Non-GMO Badges" ||
        typeCheck == "USDA Organic"
      ) {
        return "bushel-ops-usda";
      }
      if (typeCheck == "Kosher") {
        return "bushel-ops-kosher";
      }
      if (typeCheck == "GMP Certification" || typeCheck == "GMP") {
        return "bushel-ops-gmp";
      }
      if (typeCheck == "Non GMO" || typeCheck == "GMO") {
        return "bushel-ops-gmo";
      }
      if (typeCheck == "cGMP Certification" || typeCheck == "cGMP" || typeCheck == "CGMP Certification" || typeCheck == "CGMP") {
        return "bushel-ops-cgmp";
      }
      if (typeCheck == "Lab Certification") {
        return "bushel-ops-gov rounded";
      }
      if (typeCheck == "Fit For Commerce Certification") {
        return "bushel-ops-gov rounded";
      }
      if (typeCheck == "SIP Certification" || typeCheck == "SIP" || typeCheck == "sip Certification" || typeCheck == "sip") {
        return "bushel-ops-sip";
      }
      if (typeCheck == "Clean Green") {
        return "bushel-ops-clean-green fa-rotate-270";
      }
      if (typeCheck == "DEM Pure") {
        return "bushel-dem-pure rounded";
      }
      return "far fa-file-alt fa-fw fa-2x";
    },
    downloadLink(doc) {
      return doc.id ? `/b-api/docs/public-download/${doc.uuid}` : doc.file;
    },
  },
};
</script>

<style scoped>
/*Allow Browsers to print background images - in our case icons..*/
* {
  -webkit-print-color-adjust: exact !important;
  /* print-color-adjust: exact !important; */
}
:deep(.popover-body) {
  padding: 0;
}
:deep(.list-group-item) {
  padding: 0.35rem 1.25rem;
}
</style>
